/**
 * Save a Blob the browser fetched with the dashboard's auth header (castr's
 * `.csv` endpoints cannot be linked directly, so the file is downloaded and
 * handed to the browser as an object URL).
 */
export function saveBlob(blob, filename) {
	const url = URL.createObjectURL(blob)
	const link = document.createElement('a')
	link.href = url
	link.download = filename
	link.rel = 'noopener'
	document.body.appendChild(link)
	link.click()
	link.remove()
	setTimeout(() => URL.revokeObjectURL(url), 1000)
}

/** `Acme TV` → `acme-tv` for download file names. */
export function slugForFile(name, fallback = 'site') {
	const slug = String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
	return slug || fallback
}
